import {
  TechDocPage,
  TechDocChecklistPage,
  TechDocWizardPage,
} from '../containers/pages';
import { gettingStarted } from './pageConfigComm';
import {
  DHCI_RACK_VIDEO,
  // DHCI_CABLE_VIDEO,
  DHCI_CABLE_STEP1_VIDEO,
  DHCI_SWITCH_CONFIGURE_VIDEO,
  DHCI_CABLE_STEP1_BROWN_VIDEO,
  DHCI_SWITCH_CONFIGURE_BROWN_VIDEO,
  // UNBOX_VIDEO,
  // CABLES_VIDEO,
  // RACK_STEP1_VIDEO,
  // RACK_STEP2_VIDEO,
  // RACK_STEP3_VIDEO,
  // POWER_VIDEO,
} from '../constants';
import { ALLETRA6k_VIDEO_URL } from '../constants';

export const dHCI6KPagesConfig = [
  ...gettingStarted(),
  {
    path: '/physical-install',
    menuText: 'physicalInstallation',
    exact: true,
    redirectTo: '/physical-install/unbox',
    submenuItems: [
      {
        path: '/physical-install/unbox',
        menuText: 'unbox',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRA6k_VIDEO_URL.DHCI_UNBOX,
        },
      },
      {
        path: '/physical-install/rackArray',
        menuText: 'rackArray',
        exact: true,
        redirectTo: '/physical-install/rackArray/1',
      },
      {
        path: '/physical-install/rackArray/:step',
        exact: true,
        component: TechDocWizardPage,
        pageName: 'rackArray',
        pageProps: {
          steps: [
            {
              videoUrl: ALLETRA6k_VIDEO_URL.DHCI_RACK_ARRAY_STEP1,
            },
            {
              videoUrl: ALLETRA6k_VIDEO_URL.DHCI_RACK_ARRAY_STEP2,
            },
            {
              videoUrl: ALLETRA6k_VIDEO_URL.DHCI_RACK_ARRAY_STEP3,
            },
          ],
        },
      },
      {
        path: '/physical-install/rackServersSwitches',
        menuText: 'rackServersSwitches',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: DHCI_RACK_VIDEO,
        },
      },
      {
        path: '/physical-install/cable',
        menuText: 'cable',
        exact: true,
        redirectTo: '/physical-install/cable/1',
      },
      {
        path: '/physical-install/cable/:step',
        exact: true,
        component: TechDocWizardPage,
        pageName: 'cable',
        pageProps: {
          steps: [
            {
              videoUrl_green: DHCI_CABLE_STEP1_VIDEO,
              videoUrl_brown: DHCI_CABLE_STEP1_BROWN_VIDEO,
            },
            {
              videoUrl_green: '',
              videoUrl_brown: '',
            },
            {
              videoUrl_green: '',
              videoUrl_brown: '',
            },
          ],
        },
      },
      {
        path: '/physical-install/powerOn',
        menuText: 'powerOn',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRA6k_VIDEO_URL.DHCI_POWER,
        },
      },
    ],
  },
  {
    path: '/software-config',
    menuText: 'softwareConfig',
    exact: true,
    redirectTo: '/software-config/configSwitch',
    submenuItems: [
      {
        path: '/software-config/configSwitch',
        menuText: 'configSwitch',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl_green: DHCI_SWITCH_CONFIGURE_VIDEO,
          videoUrl_brown: DHCI_SWITCH_CONFIGURE_BROWN_VIDEO,
        },
      },
      {
        path: '/software-config/prepareEnv',
        menuText: 'prepareEnv',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/software-config/arrayDiscovery',
        menuText: 'arrayDiscovery',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/software-config/connectArray',
        menuText: 'connectArray',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/software-config/arraySetup',
        menuText: 'arraySetup',
        exact: true,
        component: TechDocPage,
        pageProps: {
          // contentType: 'react-showdown',
        },
      },
      {
        path: '/software-config/validation',
        menuText: 'arrayValidation',
        exact: true,
        component: TechDocChecklistPage,
        pageProps: {},
      },

      {
        path: '/software-config/completeSetup',
        menuText: 'setupComplete',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
    ],
  },
];
